import { Common } from '@thecvlb/design-system';
import classNames from 'classnames';

import VoiceIndicator from 'widgets/zoom/VoiceIndicator';

import ZoomVideoContainer from '../../ZoomVideoContainer';

import { ParticipantProps } from './participant.types';
import { useParticipantHook } from './participant.hook';

const Participant: React.FC<ParticipantProps> = ({
  bVideoOn,
  isMain,
  isSpeaking,
  muted,
  userId
}) => {
  const { containerId } = useParticipantHook({
    bVideoOn,
    isMain,
    userId
  });
  const showVoiceIndicator = (!bVideoOn || (isSpeaking && !isMain)) && !muted;
  const showMutedIcon = muted && !isMain;

  return (
    <>
      <ZoomVideoContainer
        className={classNames({
          'bg-gray-700': !isMain,
          'hidden!': !bVideoOn && !isMain,
          'video-call-bg': isMain
        })}
        id={containerId}
      />
      {showVoiceIndicator && (
        <VoiceIndicator isSpeaking={isSpeaking} bVideoOn={bVideoOn} isMain={isMain} />
      )}
      {showMutedIcon && (
        <Common.Icon
          name="microphone-off"
          className={classNames('right-1 top-1 size-7 rounded-full p-1 text-white bg-black/40', {
            absolute: bVideoOn
          })}
        />
      )}
    </>
  );
};

export default Participant;
